import CheckoutSidebarContainer from './CheckoutSidebarContainer';
export default CheckoutSidebarContainer;